export enum NafathStatusEnums {
  WAITING = 'waiting',
  EXPIRED = 'expired',
  REJECTED = 'rejected',
  COMPLETED = 'completed',
  NOT_REQUIRED = 'not_required',
  NOT_COMPLETED = 'not_completed',
  DEPRECATED = 'deprecated',
}
